var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"analytics-banner pa-3",class:{
    '-with-top-border': _vm.withTopBorder,
    '-with-orange-border': _vm.withOrangeBorder,
    '-flexible': _vm.flexible,
  }},[_c('v-layout',{attrs:{"column":"","fill-height":"","ma-0":""}},[_c('v-flex',{attrs:{"pa-0":""}},[_vm._t("header")],2),_c('v-flex',{attrs:{"pa-0":""}},[_vm._t("sub-header")],2),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }